import fetch from 'isomorphic-fetch';

import { AUTH_COOKIE_DOMAIN, IS_CLIENT } from '../constants/session';
import { BZNAV_SESSION_ID, BZNAV_CLIENT_SESSION_ID } from '../constants/storage-keys';

import { getCookieData, setCookieData } from './cookie';
import { uuidV4 } from './strings';

export const getSessionId = () => {
  if (!IS_CLIENT) return '';

  const savedSessionId = getCookieData(BZNAV_SESSION_ID);
  if (savedSessionId) {
    return savedSessionId;
  }
  const newSessionId = uuidV4();
  setCookieData(BZNAV_SESSION_ID, newSessionId, { domain: AUTH_COOKIE_DOMAIN, path: '/', maxAge: 60 * 60 * 24 * 365 * 20 });
  return newSessionId;
};

export const getClientSessionId = () => {
  if (!IS_CLIENT) return '';

  const savedSessionId = sessionStorage.getItem(BZNAV_CLIENT_SESSION_ID);
  if (savedSessionId) {
    return savedSessionId;
  }
  const newSessionId = uuidV4();
  sessionStorage.setItem(BZNAV_CLIENT_SESSION_ID, newSessionId);
  return newSessionId;
};

export const getClientIpAddress = async () => {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return await data.ip;
};
